import React from "react";
import { motion } from "framer-motion";
import "./ProjectSection.scss";
import { FaRegEye } from "react-icons/fa";
import { BsGithub } from "react-icons/bs";
import { ImHtmlFive2, ImCss3 } from "react-icons/im"
import { TbBrandJavascript } from "react-icons/tb"
import { SiReact, SiChakraui, SiRedux, SiExpress, SiMongodb } from "react-icons/si"
import { FaNodeJs } from "react-icons/fa"
const Projects = () => {
  const [rot1, setRot1] = React.useState(false);
  const [rot2, setRot2] = React.useState(false);
  const [rot3, setRot3] = React.useState(false);
  const [rot4, setRot4] = React.useState(false);
  const [rot5, setRot5] = React.useState(false);
  const [rot6, setRot6] = React.useState(false);

  return (
    <div id="projects" className="projects">
      <h2>Projects</h2>
      <motion.div
        whileInView={{ y: [50, 0], opacity: [0, 1] }}
        transition={{ duration: 1 }}
        className="projectsdiv"
      >
        <motion.div whileHover={{ scale: 1.05 }} transition={{ duration: 0.3 }}>
          <motion.img src="https://i.ibb.co/7yrNh2Q/bigbasket.png" />
          <br />
          <section>
            <h1>Nature Trug</h1>
            <p>
              An online Supermarket that provides all kinds of groceries. With a wide
              range of products from top brands. It's easy to
              navigate and has a user-friendly interface, this website is the
              perfect one-stop for all you basic needs.
            </p>
            <span style={{ display: "flex" }}>
              <h4>Tech Stack</h4>
              <div style={{ display: "flex", width: '70%' }}>
                <SiReact color="#00d1f7" className="parag" />
                <SiChakraui color="#50ca94" className="parag" />
                <SiRedux color="#7248b6" className="parag" />
                <ImCss3 color="#254bdd" className="paragjs" />
              </div>
            </span>
          </section>
          <div>
            <motion.button
              whileHover={{ scale: 1.1 }}
              animate={{ rotate: rot1 ? 360 : 0 }}
              onClick={() => setRot1(!rot1)}
            >
              <a target={"_black"} href="https://63cd625dfe08a640146165f6--unique-heliotrope-35567e.netlify.app/">
                <p>
                  <FaRegEye />
                </p>
              </a>
            </motion.button>

            <motion.button
            >
              <a target={"_black"} href="https://github.com/chintasiva/NatureTrugg.com">
                <p>
                  <BsGithub />
                </p>
              </a>
            </motion.button>
          </div>
        </motion.div>

        <motion.div whileHover={{ scale: 1.05 }} transition={{ duration: 0.3 }}>
          <motion.img src="https://i.ibb.co/T4BDCGL/I2J.png" />
          <br />
          <section>
            <h1>I 2 J</h1>
            <p>
              Online website which will provide Jobs and Internships. User can find the Interships and Jobs in different domains like Computer Science, Medical, Transportation etc.
            </p>

            <span style={{ display: "flex" }}>
              <h4>Tech Stack</h4>
              <div style={{ display: "flex", width: '70%' }} >
                <ImHtmlFive2 color="#dd4b25" className="parag" />
                <ImCss3 color="#254bdd" className="parag" />
                <TbBrandJavascript color="#efd81c" className="parag" />
              </div>
            </span>

          </section>
          <div>
            <motion.button
            >
              <a target={"_black"} href="https://spontaneous-maamoul-93e046.netlify.app/">
                <p>
                  <FaRegEye />
                </p>
              </a>
            </motion.button>

            <motion.button
              whileHover={{ scale: 1.1 }}
              animate={{ rotate: rot4 ? 360 : 0 }}
              onClick={() => setRot4(!rot4)}
            >
              <a target={"_black"} href="https://github.com/chintasiva/Intern-Theory">
                <p>
                  <BsGithub />
                </p>
              </a>
            </motion.button>
          </div>
        </motion.div>

        <motion.div whileHover={{ scale: 1.05 }} transition={{ duration: 0.3 }}>
          <motion.img src="https://i.ibb.co/80GBGNk/lately.png" />
          <br />
          <section>
            <h1>Lately</h1>
            <p>
              Lately is an AI-powered content generator and social media management platform that re-purposes longform text, video and podcasts. Lately's AI learns any brand or individual voice and pinpoints the ideas, words and phrases that will convert any target audience.
            </p>
            <span style={{ display: "flex" }}>
              <h4>Tech Stack</h4>
              <div style={{ display: "flex", width: '70%' }}>
                <ImHtmlFive2 color="#dd4b25" className="parag" />
                <ImCss3 color="#254bdd" className="parag" />
                <TbBrandJavascript color="#efd81c" className="paragjs" />
              </div>
            </span>
          </section>
          <div>
            <motion.button
              whileHover={{ scale: 1.1 }}
              animate={{ rotate: rot5 ? 360 : 0 }}
              onClick={() => setRot5(!rot5)}
            >
              <a target={"_black"} href="https://sparkly-bonbon-c2f9bd.netlify.app/">
                <p>
                  <FaRegEye />
                </p>
              </a>
            </motion.button>

            <motion.button
            >
              <a target={"_black"} href="https://github.com/chintasiva/Lately">
                <p>
                  <BsGithub />
                </p>
              </a>
            </motion.button>
          </div>
        </motion.div>


        <motion.div whileHover={{ scale: 1.05 }} transition={{ duration: 0.3 }}>
          <motion.img src="https://i.ibb.co/yRprFBd/Lintsnap.png" />
          <br />
          <section>
            <h1>LINT</h1>
            <p>
              LINT is a online Shopping website that provides all kinds of fabrics. It provide a wide range of product categories from top brands. It will also provide a jewelry, handbags, beauty products. It's easy to
              navigate and has a user-friendly interface.
            </p>
            <span style={{ display: "flex" }}>
              <h4>Tech Stack</h4>
              <div style={{ display: "flex", width: '70%' }}>
                <SiReact color="#00d1f7" className="parag" />
                <SiChakraui color="#50ca94" className="parag" />
                <SiRedux color="#7248b6" className="parag" />
                <ImCss3 color="#254bdd" className="paragjs" />
                <FaNodeJs color="#479848" className="paragjs" />
                <SiExpress color="black" className="paragjs" />
                <SiMongodb color="#479848" className="paragjs" />
              </div>
            </span>
          </section>
          <div>
            <motion.button
              whileHover={{ scale: 1.1 }}
              animate={{ rotate: rot5 ? 360 : 0 }}
              onClick={() => setRot5(!rot5)}
            >
              <a target={"_black"} href="https://lint-ecommerce.netlify.app/">
                <p>
                  <FaRegEye />
                </p>
              </a>
            </motion.button>

            <motion.button
            >
              <a target={"_black"} href="https://github.com/RimRaider639/opposite-memory-3690">
                <p>
                  <BsGithub />
                </p>
              </a>
            </motion.button>
          </div>
        </motion.div>




        <motion.div whileHover={{ scale: 1.05 }} transition={{ duration: 0.3 }}>
          <motion.img src="https://i.ibb.co/NLzwj8n/main-page-rps.png" />
          <br />
          <section>
            <h1>Rock Paper Scissors</h1>
            <p>
              Rock Paper Scissors is a gamimg application. It works like the actual rules of the Rock Paper Sicssors game.
            </p>
            <span style={{ display: "flex" }}>
              <h4>Tech Stack</h4>
              <div style={{ display: "flex", width: '70%' }}>
                <SiReact color="#00d1f7" className="parag" />
                <ImCss3 color="#254bdd" className="paragjs" />
              </div>
            </span>
          </section>
          <div>
            <motion.button
              whileHover={{ scale: 1.1 }}
              animate={{ rotate: rot5 ? 360 : 0 }}
              onClick={() => setRot5(!rot5)}
            >
              <a target={"_black"} href="https://rps-chintasiva.vercel.app/">
                <p>
                  <FaRegEye />
                </p>
              </a>
            </motion.button>

            <motion.button
            >
              <a target={"_black"} href="https://github.com/chintasiva/Rock-Paper-Scissors/tree/main/">
                <p>
                  <BsGithub />
                </p>
              </a>
            </motion.button>
          </div>
        </motion.div>

      </motion.div>


      
    </div>
  );
};

export default Projects;
